import React, { Component } from 'react';
import { withDomains, RESTExecutor } from '../../../lib/domain';

import { Row, Table, Button, Input } from 'antd';
import Title from 'antd/lib/typography/Title';
import { PopUpForm } from '../../../lib/ui/popupform';
import { formatMoney } from '../../../lib/util';

const reconcilers_cols = ({ onEditPressed }) => [
    {
        title: "Processor Name",
        dataIndex: "name",
        key: 'name'
    },
    {
        title: "ID",
        dataIndex: 'id',
        key: 'id'
    },
    //   {
    //       title:"",
    //       dataIndex:'id',
    //       key:'action',
    //       render:(id,data)=><Button 
    //       type='link'
    //       onClick={()=>{
    //           typeof onEditPressed==='function'&&onEditPressed(data)
    //       }}>Edit</Button>

    //   }
]

const reconciler_fields = [
    {
        index: 'id',
        name: "Processor ID",
        type: 'text',
        show_update: false
    },
    {
        index: 'name',
        name: "Processor Name",
        type: 'text'
    },
    {
        index: 'validation_config',
        name: "Validation Config",
        type: 'json'
    }
]


class ReconcilersView extends Component {
    constructor(props) {
        super(props)

        this.state = {
            form_visibility: false,
            form_data: {},
            edit_id: null
        };

        this.list_reconcilers = RESTExecutor.list().config({
            label: 'reconciler_comparators'
        }).connect(props.domains.settings);


        this.post_reconcilers = RESTExecutor.post().config({
            label: 'reconciler_comparators'
        }).callbacks((success) => {
            this.list_reconcilers.execute();

            this.setState({
                form_visibility: false,
                form_data: {},
                edit_id: null
            })
        })
            .connect(props.domains.settings);

        this.patch_reconciler = RESTExecutor.patch().config({
            label: 'reconciler_comparators_detail'
        }).forId("").callbacks((success) => {
            this.list_reconcilers.execute();

            this.setState({
                form_visibility: false,
                form_data: {},
                edit_id: null
            })

        }).connect(props.domains.settings);
    }


    handlePostPatch = (data) => {
        if (this.state.edit_id) {
            this.patch_reconciler.forId(this.state.edit_id).execute(data);
        } else {
            this.post_reconcilers.execute(data);
        }
    }

    render() {

        let list_reconcilers_res = this.list_reconcilers.response();
        let list_reconcilers_data = list_reconcilers_res.result || {};
        let post_reconciler_resp = this.post_reconcilers.response();
        let patch_reconciler_resp = this.patch_reconciler.response();
        let rowsMeta = list_reconcilers_res.meta || {}
        let rowsData = list_reconcilers_data.rows || [];
        let filteredData = JSON.parse(JSON.stringify(rowsData));
        if (this.state.query) {
            filteredData = filteredData.filter(({ name = "", id = "", description = "" }) => {
                name = name.toLowerCase();
                id = id.toLowerCase();
                description = description.toLowerCase();
                return name.includes(this.state.query.toLowerCase())
                    || id.includes(this.state.query.toLowerCase())
                    || description.includes(this.state.query.toLowerCase())
                    ;
            });
        }
        return (
            <div>

                <Table
                    scroll={{ x: true }}
                    loading={list_reconcilers_res.fetching}
                    columns={reconcilers_cols({
                    })}
                    pagination={{
                        showTotal: (total, range) => `${formatMoney(range[0], 0)}-${formatMoney(range[1], 0)} of ${formatMoney(total, 0)} items`
                    }}
                    dataSource={filteredData}
                    className='main-table' size='small'
                    // pagination={{
                    //     simple: true,
                    //     onChange: (current, size) => {
                    //         this.list_reconcilers.config({
                    //             params: {
                    //                 per_page: size,
                    //                 page: current
                    //             }
                    //         }).execute();
                    //     },
                    //     defaultCurrent: 1,
                    //     current: rowsMeta.pagination && parseInt(rowsMeta.pagination.split('/')[0]),
                    //     // defaultPageSize: 20,
                    //     pageSize: (rowsMeta && rowsMeta.requested_count),

                    //     total: (rowsMeta && rowsMeta.total_count),
                    //     showTotal: (total, range) => `${formatMoney(range[0],0)}-${formatMoney(range[1],0)} of ${formatMoney(total,0)} items`
                    // }}
                    title={() => <div><Row type='flex' justify='space-between' style={{
                        alignItems: 'center'
                    }}><Title
                        type='secondary'
                        level={3}

                        style={{
                            margin: 0
                        }}>Processor List</Title>
                        {/* <Button type='primary' onClick={() => {
                        this.setState({
                            edit_id: null,
                            form_data: {},
                            form_visibility: true
                        })
                    }}>Add New Processor</Button> */}
                    </Row>
                        <br></br>
                        <Row type='flex'
                            justify='space-between'
                            style={{
                                alignItems: 'center',
                                flexWrap: 'nowrap'
                            }}>
                            <Input.Search
                                placeholder="Search For"
                                style={{
                                }} autoFocus
                                value={this.state.query}
                                onChange={(e) => {
                                    this.setState({ query: e.target.value })
                                }}
                            /> {this.state.query && this.state.query.length > 0 && <Button
                                style={{
                                    marginLeft: 4
                                }}
                                type='danger'
                                shape="circle"
                                icon="close-circle"
                                onClick={() => {
                                    this.setState({ query: null })
                                }} />}
                        </Row>
                    </div>}
                    rowKey={(record) => record.id}
                />
            </div>
        )
    }

    componentDidMount() {
        this.list_reconcilers.execute()
    }
}

export default withDomains(ReconcilersView, "settings");
